import React from 'react';

import { generateMetaTags } from 'helpers/metaTags';
import DocMeta from 'components/DocMeta';
import ContactList from "../../components/layout/contacts/ContactList";
import {connect, useSelector} from "react-redux";
import {intlModule} from "@chedri/base";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

function ContactManagement() {
  const messages = useSelector(intlModule.selectors.getMessages);

  return (
    <DocMeta tags={generateMetaTags(messages.contact, messages.contact)}>
      <ContactList />
    </DocMeta>
  );
}

export default injectIntl(
  withRouter(
    connect()(ContactManagement)
  )
);
